<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '../../lib/utils'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>
<template>
  <div
    :class="
      cn('text-muted-foreground text-wrap text-sm leading-3', props.class)
    "
  >
    <slot />
  </div>
</template>
